import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDebouncedCallback } from 'use-lodash-debounce'
import { Fieldset, Legend, InputField, Textarea, Label } from './styled'
import ValidationBar from '../common3/ValidationBar'
import get from 'lodash/get'
import setDefaultValue from './setDefaultValue'
import HelpIcon from '../common3/HelpBox/Icon'
import HelpBox from "../common3/HelpBox";

const Input = (props) => {
  // const [ value, setValue ] = useState(props.value)
  const {
    extra = {},
    value, // <-- important not to set this to anything. We use undefined to check against default value.
    save = () => { },
    disableValidation = false,
    validationError = '', 
    id,
    isSummary = false,
    user = {},
    label: propsLabel,
    onChange = undefined,
    height: propsHeight = undefined,
    onKeyDown = () => { },
    htmlTemplates = {},
    dispatchEvent = () => {},
  } = props;

  let {
    name,
    label = 'Test',
    style = 'h1',
    textAlign = 'left',
    height = '55',
    multipleLines = false,
    multipleLinesAmount = 5,
    type = 'text',
    subLabel = '',
    placeholder = '',
    defaultValue = null,
    staticValue = null,
    helpBoxAlwaysVisible = false,
    helpBoxOnFocus = false,
    helpBoxIcon = false,
    helpBoxTemplateId = null,
    helpBoxTemplate = null
  } = extra;

  const { validation = {}, events = {} } = extra
  const { required = false } = validation
  const { onChange : onChangeEvent } = events

  const disabled = props.disabled || extra.disabled

  const [inputValue, setInputValue] = useState(value !== undefined ? value : '')

  const [helpBoxOpen, setHelpBoxOpen] = useState(helpBoxAlwaysVisible ? true : false)

  /**
   * Callback to initiate debouce saving, this is called when a user modifies a value
   */
  const debouceCallback = useCallback(value => {
    save({ key: id, value });
    if( onChangeEvent ) {
      dispatchEvent('onChange', value)
    }
  }, [value, id])

  const [inputFocused, setInputFocused] = useState(false)
  const debouncedSetValue = useDebouncedCallback(debouceCallback, props.debounceTimer ? props.debounceTimer : 500);


  height = propsHeight ? propsHeight : multipleLinesAmount > 1 ? 55 : height

  let error = validationError.critical ? 'critical' : null
  let errorMessage = validationError.critical
  if (!error) {
    error = validationError.error ? 'danger' : null
    errorMessage = validationError.error
  }
  if (!error) {
    error = validationError.warning ? 'warning' : null
    errorMessage = validationError.warning
  }

  /**
   * Effect to handle incoming new values, i.e. changes from outside the component
   * 
   * Notice that we do not call debouceSetValue, but we cancel all values
   */
  useEffect(() => {
    if (value === undefined || value === null) {
      const defaultValue = setDefaultValue({ extra, user, props, context: {} })

      if (defaultValue) {

        setInputValue(defaultValue)
        save({ key: id, value: defaultValue });
        //debouncedSetValue.cancel()
      }
    } else
      if (inputValue !== value) {
        /**
         * Why do we do replace? In summary: This is a very technical issue, and do not remove it.
         * It is because JSON.parse does not accept \n, and when we run filterString with newlines it will 
         * crash. So we have to do a couple of things to fix this. Among these are replacing string \n with real newline-chars.
         */
        setInputValue(value && typeof value === 'string' && value.replaceAll('\\n', '\n'))
        debouncedSetValue.cancel()

      }
  }, [value])


  const onBlur = useCallback(() => {
    setInputFocused(false)
    if (inputValue !== value) {
      save({ key: id, value: inputValue });
    }
  }, [inputValue, save, id, value])

  /**
   * Callback for changes. This sets the internal state AND set debouceValue
   */
  const _setInputValue = useCallback(e => {
    setInputValue(e.target.value)
    debouncedSetValue(e.target.value)
  }, [])

  const fixedLabel = type === 'time'

  const _helpBoxTemplate = helpBoxTemplateId === '_custom' ? helpBoxTemplate : get(htmlTemplates, [helpBoxTemplateId, 'html'], '')

  return (
    <React.Fragment>
      {
        !helpBoxAlwaysVisible && helpBoxIcon && <HelpIcon toggle={() => setHelpBoxOpen(!helpBoxOpen)} />
      }
      <Fieldset focused={inputFocused} error={error} height={multipleLines === true ? '' : height} disabled={disabled} className={required ? 'sp-required' : ''}>
        {(inputFocused || inputValue || fixedLabel) && <Legend aria-hidden="true">{propsLabel ? propsLabel : label}</Legend>}
        {/* <Legend>{(inputFocused || inputValue) ? label : ''}</Legend> */}
        <Label focused={inputFocused} inputLength={inputValue} fixed={fixedLabel} error={error} height={height} disabled={disabled}>{propsLabel ? propsLabel : label}</Label>
        {multipleLines === true
          ?
          <Textarea
            name={name}
            rows={multipleLinesAmount}
            value={inputValue}
            onChange={_setInputValue}
            onFocus={() => { setInputFocused(true); !helpBoxAlwaysVisible && helpBoxOnFocus && setHelpBoxOpen(true) }}
            onBlur={() => { setInputFocused(false); !helpBoxAlwaysVisible && helpBoxOnFocus && setHelpBoxOpen(false) }}
            onKeyDown={onKeyDown}
            required={required}
          />
          :
          <InputField
            name={name}
            type={type}
            value={inputValue}
            onChange={onChange ? onChange : _setInputValue}
            onFocus={() => { setInputFocused(true); !helpBoxAlwaysVisible && helpBoxOnFocus && setHelpBoxOpen(true) }}
            onBlur={() => { onBlur(); !helpBoxAlwaysVisible && helpBoxOnFocus && setHelpBoxOpen(false) }}
            disabled={disabled}
            onKeyDown={onKeyDown}
            required={required}
          />
        }
      </Fieldset>
      {
        (helpBoxAlwaysVisible || helpBoxOnFocus || helpBoxIcon) && _helpBoxTemplate && helpBoxOpen && (
          <HelpBox template={_helpBoxTemplate} props={props} value={value} />
        )
      }
      <ValidationBar error={errorMessage} subLabel={subLabel} disableValidation={disableValidation} />

    </React.Fragment>

  );
};

export default Input